/*
 * Copyright (C) 2012, 2013, 2014 Minted Inc.
 *
 * All Rights Reserved
 */

M.Model = M.Model || {};
M.Model.Sample = M.Model.Sample || {};

/**
 * @class M.Model.Sample.SampleDialog
 */
M.Model.Sample.SampleDialog = Backbone.Model.extend({
  defaults: {
    colorChoices: null,
    defaultColor: null,
    disclaimer: '',
    greetingUrlParam: '',
    hasCustomColors: false,
    instructions: null,
    isWedding: false,
    paperChoices: null,
    productName: null,
    promoCode: null,
    sampleUsesGenericBacker: false,
    selectedColor: null,
    selectedPaper: null,
    selectedUserColors: [],
    selectedWeddingDay: null,
    selectedWeddingMonth: null,
    selectedWeddingYear: null,
    shouldOnlyShowDefaultColorway: null,
    sku: null,
    skuParts: null,
    thumbnailUrl: null,
    source: null,
    sampleCost: 1,
    isLetterpress: false,
    isFoilPress: false
  },

  initialize: function() {
    var that = this;
    M.required(this.get('sku'));

    this.skuParts = this.get('sku').match(/^([^-]+)-([^-]+)-([^-]+)$/);

    // Enhance the paper choices object.
    _.each(this.get('paperChoices'), function(paperChoice) {
      paperChoice.name = M.Model.ProductDetails.PAPER_OPTION_LABELS[paperChoice.id];
      paperChoice.description = M.View.ProductDetails.PAPER_CAPTIONS[paperChoice.id];
    });

    // Enhance the colorChoices object so that it has a thumbnail property.
    // TODO: is this even necessary? Can't the colorChoice image url be passed
    // in with the bootstrapped data?
    _.each(this.get('colorChoices'), function(colorChoice) {
      colorChoice['thumbnail'] = that.getColorWayThumbnailUrl(colorChoice);
    });

    if (this.get('shouldOnlyShowDefaultColorway')) {
      this.get('colorChoices').splice(1);
    }

    var colorOptionDesc = this.get('colorChoices').length > 1 ? '' : ' in one color';

    if (this.get('isLetterpress')) {
      var filteredPaperChoices = _(this.get('paperChoices')).filter(function(paper) {
        return paper.id == M.Model.ProductDetails.SOMERSET_500;
      });

      this.set({
        disclaimer: 'Letterpress samples are only available in our premium 100% \
cotton paper' + colorOptionDesc + '. All samples come with a color palette.',
        paperChoices: filteredPaperChoices
      });
    }

    if (this.get('isFoilPress')) {
      var filteredPaperChoices = _(this.get('paperChoices')).filter(function(paper) {
        return [ 
          M.Model.ProductDetails.SIGNATURE, 
          M.Model.ProductDetails.STRATHMORE, 
          M.Model.ProductDetails.MAGNET
        ].includes(paper.id);
      });

      var has_signature_cover = filteredPaperChoices.find(function(paper) {
        return paper.id == M.Model.ProductDetails.STRATHMORE;
      });

      var has_magnet = filteredPaperChoices.find(function(paper) {
        return paper.id == M.Model.ProductDetails.MAGNET;
      });

      //TODO: Need to refactor this code and make it data driven.
      var disclaimer = "Foil samples are only available in our signature paper" + colorOptionDesc + ". All samples come with a color palette.";

      if(has_magnet){
        disclaimer = disclaimer.replace('signature','magnet');
      }
      else if(has_signature_cover){
        disclaimer = disclaimer.replace('signature','signature cover');
      }

      this.set({
        disclaimer: disclaimer,
        paperChoices: filteredPaperChoices
      });
    }

    this.setDefaults();
  },

  /**
   * Set up default selected values.
   */
  setDefaults: function() {
    // Default to the first paper and color choice
    this.set({
      'selectedPaper': this.get('paperChoices')[0],
      'selectedPaperId': this.get('paperChoices')[0] ? this.get('paperChoices')[0].id : null,
      'selectedColor': this.get('colorChoices')[0],
      'thumbnailUrl': this.getThumbnailUrl()
    });
  },

  /**
   * Returns the sku thumbnail url.
   */
  getThumbnailUrl: function() {
    "use strict";
    var productImage = new M.Model.ProductImage({
      sku: this.get('sku'),
      viewCode: M.PRODUCT_IMAGE.VIEW_CODE.FRONT,
      photoCode: null,
      colorCode: "A",
      greeting: this.get("greetingUrlParam")
    });
    return productImage.getImgUrl();
  },

  /**
   * Returns the colorway image url.
   */
  getColorWayThumbnailUrl: function(colorChoice) {
    "use strict";
    var colorCode = (colorChoice.color || colorChoice.code).toUpperCase();
    var productImage = new M.Model.ProductImage({
      sku: this.get('sku'),
      viewCode: M.PRODUCT_IMAGE.VIEW_CODE.FRONT,
      photoCode: M.PRODUCT_IMAGE.PHOTO_CODE.TH,
      colorCode: colorCode,
      greeting: this.get("greetingUrlParam")
    });

    return productImage.getImgUrl();
  }
});
